import { jsx } from 'react/jsx-runtime';
import { ScrollArea } from '../../ScrollArea/ScrollArea.es.js';

const SideSheetBody = ({ children })=>{
    return jsx(ScrollArea, {
        className: "cb-side-sheet-scroll-area",
        "data-testid": "side-sheet-body",
        maskStyle: "shadow",
        children: jsx("div", {
            className: "cb-side-sheet-scroll-area-content",
            children: children
        })
    });
};
SideSheetBody.displayName = 'SideSheet.Body';

export { SideSheetBody };
//# sourceMappingURL=SideSheet.Body.es.js.map
